import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownComponent } from './dropdown/dropdown.component';
import { TextNormalComponent } from './text-normal/text-normal.component';
import { MaterialModule } from '../../../shared/material.module';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { FileUploadModule } from 'ng2-file-upload';
import { TimeComponent } from './time/time.component';
import { DateTimeComponent } from './date-time/date-time.component';
import { MatNativeDateModule } from '@angular/material';
import { NumberComponent } from './number/number.component';
import { DropdownTeachersComponent } from './dropdown-teachers/dropdown-teachers.component';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { DropdownDegreeComponent } from './dropdown-degree/dropdown-degree.component';
import { DropdownDegreeComponent2 } from './dropdown-degree2/dropdown-degree.component';
import { DropdownProjectComponent } from './dropdown-project/dropdown-project.component';
import { DropdownResearchComponent } from './dropdown-research/dropdown-research.component';
import { DropdownTeachersBookComponent } from './dropdown-teachersbook/dropdown-teachersbook.component';
import { DropdownDegreeInternComponent } from './dropdown-degree-intern/dropdown-degree-intern.component';
import { DropdownTeacherPointComponent } from './dropdown-teacher-point/dropdown-teacher-point.component';
@NgModule({
  imports: [
    MaterialModule,
    FileUploadModule,
    CommonModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    TextNormalComponent,
    UploadFileComponent,
    DropdownComponent,
    TimeComponent,
    DateTimeComponent,
    NumberComponent,
    DropdownTeachersComponent,
    RadioButtonComponent,
    DropdownDegreeComponent,
    DropdownDegreeComponent2,
    DropdownProjectComponent,
    DropdownResearchComponent,
    DropdownTeachersBookComponent,
    DropdownDegreeInternComponent,
    DropdownTeacherPointComponent,
  ],
  exports: [
    TextNormalComponent,
    UploadFileComponent,
    DropdownComponent,
    TimeComponent,
    DateTimeComponent,
    NumberComponent,
    DropdownTeachersComponent,
    RadioButtonComponent,
    DropdownDegreeComponent,
    DropdownDegreeComponent2,
    DropdownProjectComponent,
    DropdownResearchComponent,
    DropdownTeachersBookComponent,
    DropdownDegreeInternComponent,
    DropdownTeacherPointComponent,
  ]
})
export class InputModule { }
